import * as React from "react";
import { useSession } from "@/hooks/auth-hooks";

interface DashboardContextValue {
	user: {
		email?: string;
		id: string;
		image?: string | null;
		name?: string | null;
	} | null;
	isLoading: boolean;
	isPending: boolean;
}

export const DashboardContext =
	React.createContext<DashboardContextValue | null>(null);

export function useDashboardContext() {
	const context = React.use(DashboardContext);
	if (!context) {
		throw new Error(
			"useDashboardContext must be used within DashboardProvider",
		);
	}
	return context;
}

export function DashboardProvider({ children }: { children: React.ReactNode }) {
	const { user, isPending } = useSession();

	const value: DashboardContextValue = {
		user: user
			? { id: user.id, name: user.name, email: user.email, image: user.image }
			: null,
		isPending,
		isLoading: isPending,
	};

	return (
		<DashboardContext.Provider value={value}>
			{children}
		</DashboardContext.Provider>
	);
}
